export const searchModal = {
  namespaced: true,
  state: {
    showSearchModal: false,
  },
}
